import { Allowance, AllowanceStates } from 'services/api/types';

import departments from './departments';

const allowances: Allowance[] = [
  {
    id: 1,
    applicable_users: ['test@email.com'],
    name: 'Daily Expense',
    state: AllowanceStates.Active,
    applicable_weekdays: ['Mon', 'Tue', 'Fri'],
    applicable_time_from: '00:00',
    applicable_time_to: '23:59',
    budget: 20,
    budget_type: 'daily',
    allow_flexible_locations: true,
    expense_code_required_in_checkout: true,
    is_pickup: true,
    is_delivery: true,
    is_restaurant: true,
    is_shop: true,
    is_voucher: true,
    is_catering: true,
    allowance_date_from: '2021-05-01',
    applicable_locations: [1, 2, 3],
    company_departments: [departments[1]],
    applicable_users_details: [],
    applicable_type: 'group',
    meals_included: true,
    ordering_rule_company_department: [101],
    welcome_email_sent_timestamp: '2023-06-26T23:04:05'
  },
  {
    id: 2,
    applicable_users: ['test@email.com'],
    name: 'Tasty Thursday',
    state: AllowanceStates.Inactive,
    applicable_weekdays: ['Thu'],
    applicable_time_from: '00:00',
    applicable_time_to: '23:59',
    budget: 20,
    budget_type: 'weekly',
    allow_flexible_locations: true,
    expense_code_required_in_checkout: true,
    is_pickup: true,
    is_delivery: true,
    is_restaurant: true,
    is_shop: true,
    is_voucher: true,
    is_catering: true,
    allowance_date_from: '2021-05-01',
    applicable_locations: [1, 2, 3],
    company_departments: [departments[0]],
    applicable_users_details: [],
    applicable_type: 'group',
    meals_included: true,
    ordering_rule_company_department: [100]
  },
  {
    id: 3,
    applicable_users: ['test@email.com'],
    name: 'Weekends Credits',
    state: AllowanceStates.Expired,
    applicable_weekdays: ['Sat', 'Sun'],
    applicable_time_from: '00:00',
    applicable_time_to: '23:59',
    budget: 20,
    budget_type: 'monthly',
    allow_flexible_locations: true,
    expense_code_required_in_checkout: true,
    is_pickup: true,
    is_delivery: true,
    is_restaurant: true,
    is_shop: true,
    is_voucher: true,
    is_catering: true,
    allowance_date_from: '2021-05-01',
    allowance_date_to: '2021-05-02',
    applicable_locations: [1, 2, 3],
    applicable_users_details: [
      { first_name: 'Natasha', last_name: 'Romanova', email: '', id: 1 }
    ],
    applicable_type: 'user',
    meals_included: true,
    ordering_rule_company_department: []
  },
  {
    id: 4,
    applicable_users: ['test@email.com'],
    name: 'Custom Expense with no end date',
    state: AllowanceStates.Active,
    applicable_weekdays: ['Mon', 'Tue', 'Fri'],
    applicable_time_from: '00:00',
    applicable_time_to: '23:59',
    budget: 20,
    budget_type: 'custom',
    allow_flexible_locations: true,
    expense_code_required_in_checkout: true,
    is_pickup: true,
    is_delivery: true,
    is_restaurant: true,
    is_shop: true,
    is_voucher: true,
    is_catering: true,
    allowance_date_from: '2021-05-01',
    allowance_date_to: '2021-05-02',
    applicable_locations: [1, 2, 3],
    company_departments: [departments[0]],
    applicable_users_details: [],
    applicable_type: 'group',
    meals_included: true,
    ordering_rule_company_department: [100]
  },
  {
    id: 5,
    applicable_users: ['test@email.com'],
    name: 'Custom Expense with end date',
    state: AllowanceStates.Active,
    applicable_weekdays: ['Mon', 'Tue', 'Fri'],
    applicable_time_from: '00:00',
    applicable_time_to: '23:59',
    budget: 20,
    budget_type: 'custom',
    allow_flexible_locations: true,
    expense_code_required_in_checkout: true,
    is_pickup: true,
    is_delivery: true,
    is_restaurant: true,
    is_shop: true,
    is_voucher: true,
    is_catering: true,
    allowance_date_from: '2021-05-01',
    applicable_locations: [1, 2, 3],
    company_departments: [departments[0]],
    applicable_users_details: [],
    applicable_type: 'group',
    meals_included: true,
    ordering_rule_company_department: [100]
  },
  {
    id: 5,
    applicable_users: ['test@email.com'],
    name: 'Custom Expense with end date',
    state: AllowanceStates.Deleted,
    applicable_weekdays: ['Mon', 'Tue', 'Fri'],
    applicable_time_from: '00:00',
    applicable_time_to: '23:59',
    budget: 20,
    budget_type: 'custom',
    allow_flexible_locations: true,
    expense_code_required_in_checkout: true,
    is_pickup: true,
    is_delivery: true,
    is_restaurant: true,
    is_shop: true,
    is_voucher: true,
    is_catering: true,
    allowance_date_from: '2021-05-01',
    applicable_locations: [1, 2, 3],
    company_departments: [departments[0]],
    applicable_users_details: [],
    applicable_type: 'group',
    meals_included: true,
    ordering_rule_company_department: [100]
  }
];

export default allowances;
